var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinAutoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.928,7.171c0.27,0.281,0.404,0.61,0.404,0.984v7.981c0,0.234-0.129,0.352-0.387,0.352h-3.34 c-0.258,0-0.387-0.117-0.387-0.352v-2.25H4.957v2.25c0,0.234-0.117,0.352-0.352,0.352H1.23c-0.258,0-0.387-0.117-0.387-0.352V8.156 c0-0.375,0.135-0.703,0.404-0.984S1.839,6.75,2.214,6.75h0.281l1.582-4.465C4.335,1.77,4.734,1.511,5.273,1.511h7.629 c0.539,0,0.938,0.246,1.195,0.738l1.582,4.5h0.281C16.336,6.75,16.658,6.89,16.928,7.171z M8.718,13.113V2.25H5.273 c-0.234,0-0.41,0.105-0.527,0.316L3.128,7.242c-0.07,0.164-0.188,0.246-0.352,0.246H2.214c-0.164,0-0.311,0.065-0.439,0.193 C1.646,7.81,1.582,7.968,1.582,8.156v7.594h2.637V13.5c0-0.258,0.129-0.387,0.387-0.387H8.718z M3.093,10.512h3.023V9.738H3.093 V10.512z M16.594,8.156c0-0.188-0.064-0.346-0.193-0.475c-0.129-0.128-0.275-0.193-0.439-0.193h-0.562 c-0.164,0-0.281-0.082-0.352-0.246L13.43,2.531c-0.141-0.188-0.316-0.281-0.527-0.281H9.457v10.864h4.114 c0.258,0,0.387,0.129,0.387,0.387v2.25h2.637V8.156z M12.094,10.512h3.023V9.738h-3.023V10.512z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinAutoIcon);
export default __webpack_public_path__ + "static/media/zeppelin-auto-icon.f03c8d67.svg";
export { ForwardRef as ReactComponent };